import $ from 'jquery';
import ko from 'knockout';
import _ from 'underscore';

export default ko.bindingHandlers.bootstrap_dropdown = {

  init: (element) => {
    const $menu = $(element).children('.dropdown-menu');

    $(element).on('hide.bs.dropdown', () => {
      const wndEvent = window.event;
      if (!wndEvent || !wndEvent.target) {
        return undefined;
      }
      if (wndEvent.target === $menu[0] || _.contains($(wndEvent.target).parents(), $menu[0])) {
        return false;
      }

      return undefined;
    });
  },
};
